import AWS from 'aws-sdk';

const { hostname } = window.location;

if (hostname === 'console.deep-learn.in') {
  AWS.config.update({
    region: 'ap-south-1',
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: 'ap-south-1:104e6931-87e2-4846-9451-ef5754394658',
    }),
  });
} else {
  AWS.config.update({
    region: 'ap-south-1',
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: 'ap-south-1:715463fe-f2f4-4164-9335-f68a4baa8f01',
    }),
  });
}

const s3 = new AWS.S3({ apiVersion: '2006-03-01' });

export { s3 };
